"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.WRAPPER = exports.HEADER_TEXT = exports.ICON_WRAPPER = exports.HEADER = exports.FOOTER = exports.CONTENT = void 0;

var _WRAPPER,
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs2 = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    CONTENT = (0, _cxs2["default"])((0, _defineProperty2["default"])({
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  padding: "45px",
  "> .first-button": {
    marginRight: "10px"
  }
}, _vars.MEDIA_QUERIES.small, {
  paddingLeft: "0px",
  paddingRight: "0px",
  paddingBottom: "10px"
}));

exports.CONTENT = CONTENT;
var FOOTER = (0, _cxs2["default"])({
  alignItems: "center",
  display: "flex",
  fontSize: _vars.FONT_SIZES.small,
  justifyContent: "flex-start",
  minHeight: "34px",
  flexWrap: "wrap",
  marginTop: "20px",
  "> .first-button": {
    marginRight: "10px"
  }
});
exports.FOOTER = FOOTER;
var HEADER = (0, _cxs2["default"])({
  display: "flex",
  marginBottom: "20px",
  alignItems: "center"
});
exports.HEADER = HEADER;
var ICON_WRAPPER = (0, _cxs2["default"])({
  borderRadius: "17.5px",
  width: "35px",
  height: "35px",
  background: _vars.COLOURS.cyan.jungleGreen.monkey,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "15px"
});
exports.ICON_WRAPPER = ICON_WRAPPER;
var HEADER_TEXT = (0, _cxs2["default"])({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center"
});
exports.HEADER_TEXT = HEADER_TEXT;
var WRAPPER = (_WRAPPER = {
  padding: "25px"
}, (0, _defineProperty2["default"])(_WRAPPER, _vars.MEDIA_QUERIES.small, {
  padding: "25px"
}), (0, _defineProperty2["default"])(_WRAPPER, " .modal-close-icon", {
  top: "30px"
}), _WRAPPER);
exports.WRAPPER = WRAPPER;